import { Routes, RouterModule } from '@angular/router';
import { AddUserComponent } from './add-user.component';

const AddUserModule: Routes = [
  {
    path: '',
    component: AddUserComponent,
  },
];


export const MAIN_ADDUSERS = RouterModule.forChild(AddUserModule);
